export default __webpack_public_path__ + "static/media/hospitalisation.86c2ef78.svg";